import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SettingsPageSection} from "./settingsPageTypes";

interface ISettingsPage {
  selectedSection: SettingsPageSection,
}

const initialState: ISettingsPage = {
  selectedSection: "myAccount", // This does nothing! The default is set in settingsPage.ts (not .tsx)
};

export const settingsPageSlice = createSlice({
  name: 'settingsPage',
  initialState,
  reducers: (create) => ({
    selectedSectionReducer: create.reducer((state, action: PayloadAction<{selectedSection: SettingsPageSection}>) => {
      state.selectedSection = action.payload.selectedSection;
    }),
  }),
  selectors: {
    selectedSectionSelector: (state: ISettingsPage) => state.selectedSection,
  }
});

export const settingsPageReducer = settingsPageSlice.reducer;